import React, { useEffect } from 'react';
import MainSlider from '../components/MainSlider';
import Find from '../components/Find'
import Counter from '../components/Counter'
import Adoption from '../components/Adoption'
import BreedServices from '../components/BreedServices'
import Faq from '../components/Faq'
import Brand from '../components/Brand'
import Testimonial from '../components/Testimonial'
import Newsletter from '../components/NewsLetter'
import BlogsHome from '../components/BlogsHome'
import FeatureBar from '../components/Featuresbar';
import AnimaliaCategories from '../components/AnimaliaCategories';
import CategoriesList from '../components/Categories';
import CategorySection from '../components/CategorySection';
import { Helmet } from 'react-helmet-async';
import NewsletterParent from '../components/NewsletterParent';




function Home() {
	useEffect(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, []);


	return (


		<main>
			<Helmet>
				<title>Acceuil - Animalia</title>
				<meta name="description" content="Découvrez notre sélection Acceuil chez Animalia." />
			</Helmet>

			<MainSlider />
			{/* <Find/> */}
			{/* <FeatureBar/> */}
			<br />
			<br />
			<br />
			<br />
			{/* <CategoriesList/> */}
			<CategorySection />
			<br />
			<br />
			<br />
			<br />
			<Counter />
			<Adoption />
			{/* <AnimaliaCategories /> */}
			{/* <Testimonial /> */}
			{/* <BlogsHome/> */}
			<NewsletterParent />

		</main>

	)
}

export default Home;
